/**
 * Created by Dong on 2018/6/11.
 */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Button, message, Popconfirm, Popover, Radio, Space, Form, Modal, Input, DatePicker } from 'antd';
import axios from 'axios'
import moment from 'moment'
import {
    hasClaimPermission,
    hasCollectorPermission,
    hasMajorCasePermission,
    hasDefLossPermission,
} from '../../../utils/agent'
import { getReportTransferRecords, deleteReportRecord, editReportRecord, updateReportState } from '@service/report'
import RemarkBtn from '../../containers/ReportDetail/remarkBtn';
import api from '../../../utils/api'
import { formatGMTDate } from '../../../utils/index';
import './style.scss'

const { TextArea } = Input;


class ProcessedRecords extends Component {
    constructor(props) {
        super(props);
        this.state = {
            downloadBtnText: "下载文件",
            isShowSubStateConfirm: false,
            subState: 'reject',
            transferRecords: [],
            editTitle: '',
            editVisible: false,
            editData: {},
            selectedRecordId: '',
            operationType: ''
        };
    }
    recordFormRef = React.createRef();
    
    afreshPush = (action) => {

        const actionMap = {
            'eleSynClaimReport': 1,
            'eleSynClaim': 2
        }
        axios({
            method: 'post',
            url: `/api/lossAss/cpic/ele/sync`,
            data: {
                flowId: this.props.flowId,
                type: actionMap[action]
            }
        }).then(res => {
            if (res.data.errCode === 0) {
                message.success('操作成功')

            } else {
                message.error(res.data.errInfo)
            }

        }).catch(err => {

        })

    }
    /*
     * 下载文件
     * */
    handleDownLoad = () => {
        let _this = this;
        _this.setState({ downloadBtnText: '正在打包' });
        let { currentPreviewReport } = this.props;
        api('/zipFileToFtp')
            .post({ reportId: currentPreviewReport._id })
            .then(response => {
                _this.setState({ downloadBtnText: '下载文件' })
                //https://192.168.1.65:60803/zip/new.zip
                let { errCode, result } = response;
                if (result && result.length > 0) {
                    _this.downloadFile(result)
                } else {
                    message.warning('没有图片可供下载！')
                }

                //window.open(window.location.origin+'/zip/reportPic.zip');
            })
            .catch(err => {

            })
    }
    downloadFile = (url) => {
        try {
            var elemIF = document.createElement("iframe");
            elemIF.src = url;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
        } catch (e) {

        }
    }

    componentDidMount () {
        const { flowId } = this.props
        this._getReportTransferRecords(flowId)
    }

    componentDidUpdate(newProps) {
        const { flowId } = this.props
        if (newProps.flowId != flowId) this._getReportTransferRecords(flowId)
    }
    _getReportTransferRecords = () => {
        const {
            match: {
                params: { flowId }
            }
        } = this.props;
        getReportTransferRecords(flowId).then(res => {
            this.setState({
                transferRecords: res.result
            })
        })
    }

    resetReportState = async (params = {}) => {
        const { currentPreviewReport = {}, currentAgent } = this.props;
        const { flowId } = currentPreviewReport;
        await updateReportState({
            ...params,
            flowId,
            agentId: currentAgent._id
        });
        this.props.refreshReport?.();
    }

    // 已定损
    onDefLossClick = () => {
        this.resetReportState({ state: 'checked'});
    }

    // 已结案

    onFinishClick = () => {
        const { subState } = this.state;
        this.setState({ isShowSubStateConfirm: false })
        this.resetReportState({ state: 'finished', subState });
    }

    showReturnedMsg = ({ returnType = '' }) => {
        const { actions } = this.props;
        actions.setReturnedModal({ returnType })
        this.getNextTime(returnType)
    }
    getNextTime = (returnType) => {
        const { currentPreviewReport = {}, actions, currentAgent } = this.props;
        const { flowId } = currentPreviewReport;
        if (!flowId) {
            return
        }
        axios({
            method: 'get',
            url: '/api/lossAss/report/follow',
            params: {
                // flowId: currentReport && currentReport.flowId,
                flowId,

                agentId: currentAgent._id

            }
        }).then(res => {
            if (res.data.errCode == 0) {


                this.setState({
                    followDetails: res.data.result,
                    isShowNextTime: false,
                    nextTime: res.data.result.nextTime ? moment(res.data.result.nextTime) : undefined
                })

                actions.setReturnedModal({
                    isShow: true, returnType, nextTime: res.data.result.nextTime ? moment(res.data.result.nextTime) : undefined,
                    followDetails: res.data.result,
                })



            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            message.error(err.message || '请求/api/lossAss/report/follow失败')
        })
    }

    // 太保已查勘
    onCpicConfirmSurveied = () => {
        this.resetReportState({ state: 'surveied' });
    }
    // 接收任务
    acceptReport = async () => {
        const { currentPreviewReport = {}, actions, currentAgent } = this.props;
        const { flowId } = currentPreviewReport;
        await actions.acceptReport(currentPreviewReport, currentAgent._id);
        actions.getLatestReport(flowId);
    }
    // 接收定损任务
    acceptDefLossTask = async () => {
        const { currentPreviewReport = {}, actions, currentAgent } = this.props;
        const { flowId } = currentPreviewReport;
        await actions.acceptDefLossTask(currentPreviewReport, currentAgent._id);
        actions.getLatestReport(flowId);
    }

    onMouseEnter = record => {
        if (!this.props.editable) {
            return;
        }
        this.setState({
            selectedRecordId: record._id
        })
    }

    onMouseLeave = () => {
        if (!this.props.editable) {
            return;
        }
        this.setState({
            selectedRecordId: ''
        })
    }

    onEdit = record => {
        this.setState({
            operationType: 'edit',
            editData: { ...record, time: moment(record.time) },
            editVisible: true,
            editTitle: '修改'
        })
    }

    // 删除记录
    onConfirmDelete = async record => {
        try {
            await deleteReportRecord({
                flowId: this.props.flowId,
                recordId: record._id
            })
            message.success('删除成功');
            this._getReportTransferRecords();
        } catch(e) {
            console.log(e);
        }
    }


    // 下方插入
    onCreate = record => {
        this.setState({
            operationType: 'create',
            editData: { 
                time: moment(record.time)
            },
            editVisible: true,
            editTitle: '插入记录'
        })
    }

    onSubmit = () => {
        this.recordFormRef.current.validateFields().then(async values => {
            const { operationType, editData } = this.state;
            if (operationType === 'edit') {
                await editReportRecord(this.props.flowId, {
                    recordId: editData._id,
                    ...values
                })
                message.success('修改成功');
            } else {
                await editReportRecord(this.props.flowId, values)
                message.success('插入成功');
            }
            this.setState({
                editVisible: false,
                editData: {}
            })
            this._getReportTransferRecords();
        }).catch((e) => {
            console.log(e)
        })
    }

    render() {
        let _this = this;
        let { currentPreviewReport, currentAgent, flowId, disabled, editable } = _this.props;
        // let records = currentPreviewReport.transferRecords;
        const { transferRecords: records, editVisible, editTitle, selectedRecordId, editData } = this.state;
        const SUB_STATES = {
            'reject': '拒赔',
            'withdraw': '用户撤案',
            // 'remitted': '结案打款',
        };

        const { defLossTask = {}, majorCase = {} } = currentPreviewReport;
        const isDefLossAgent = currentAgent && defLossTask.agentId && (defLossTask.agentId === currentAgent._id);
        const isReportAgent = currentAgent && currentPreviewReport.agentId && ((currentPreviewReport.agentId === currentAgent._id) || (currentPreviewReport.agentId._id === currentAgent._id));
        const canDefLoss = hasDefLossPermission(currentAgent);
        const canCollector = hasCollectorPermission(currentAgent);
        const canClaim = majorCase.yes ? hasMajorCasePermission(currentAgent) : hasClaimPermission(currentAgent);
        return (
            <React.Fragment>
                <div className="div_records">
                    <span className="span_t">处理记录</span>
                    <ul className="records_ul">
                        {
                            records.map((item, index) => {
                                const { content = [], time } = item;
                                return <li key={`r_ ${item._id}`} onMouseEnter={() => this.onMouseEnter(item)} onMouseLeave={this.onMouseLeave}>
                                    <div className={`item-tail ${index == records.length - 1 ? 'end-tail' : ''}`}></div>
                                    <div className="item-icon icon_s1"></div>
                                    <div className="step_content">
                                        <div className="s_date">
                                            <p>{formatGMTDate(time)}</p>
                                            {
                                                editable ?  <div className="r-operation" style={{ display: selectedRecordId === item._id ? 'block' : 'none' }}>
                                                    <a onClick={() => this.onEdit(item)}>修改</a>
                                                    <Popconfirm
                                                        title="确定要删除该项目记录？"
                                                        onConfirm={() => this.onConfirmDelete(item)}
                                                        okText="确定"
                                                        cancelText="取消"
                                                        okButtonProps={{ danger: true  }}
                                                    >
                                                        <a>删除</a>
                                                    </Popconfirm>
                                                    <a onClick={() => this.onCreate(item)}>下方插入</a>
                                                </div> : null
                                            }
                                        </div>
                                        {
                                            content.map((text, i) => <p key={i} className="p_s1">{text.replace("重新推送", "")}</p>)
                                        }
                                        {
                                            Array.isArray(content) && content.includes('重新推送') ? <a
                                                style={{ marginLeft: 0 }}
                                                onClick={() => this.afreshPush(item.action)}
                                                type="primary"
                                            >
                                                重新推送
                                            </a> : null
                                        }
                                    </div>
                                </li>
                            })
                        }
                    </ul>
                </div>
                <div className="fastforentsics-foot" style={{ display: disabled ? 'none' : 'block' }}>
                    <div className="user-Data-foot">
                        <div >
                            {
                                ['untreated'].includes(currentPreviewReport.state)
                                && canCollector
                                && !currentPreviewReport.agentId
                                && <Button type='primary' ghost style={{ margin: '0 5px', borderColor: '#316DEE', color: '#316DEE' }} onClick={this.acceptReport} >报案接收</Button>
                            }
                            {
                                canDefLoss
                                && ['tocheck'].includes(defLossTask.state)
                                && <Button type='primary' ghost style={{ margin: '0 5px', borderColor: '#316DEE', color: '#316DEE' }} onClick={this.acceptDefLossTask} >定损接收</Button>
                            }
                            {
                                ['surveied'].includes(currentPreviewReport.state)
                                && canClaim
                                && <Button type='primary' ghost style={{ margin: '0 5px', borderColor: '#316DEE', color: '#316DEE' }} onClick={this.acceptReport} >理赔接收</Button>
                            }
                            {
                                isReportAgent
                                && canCollector
                                && ['holdedOn', 'returned'].includes(currentPreviewReport.state)
                                && <Button type='primary' ghost style={{ margin: '0 5px' }} onClick={() => this.showReturnedMsg({ returnType: 'collect' })} danger>资料退回</Button>
                            }
                            {
                                isReportAgent
                                && ['claiming', 'claimReturned'].includes(currentPreviewReport.state)
                                && <Button type='primary' ghost style={{ margin: '0 5px' }} onClick={() => this.showReturnedMsg({ returnType: 'claim' })} danger>理赔退回</Button>
                            }
                            {
                                isDefLossAgent
                                && canDefLoss
                                && ['checking'].includes(defLossTask.state)
                                && !['checked', 'finished'].includes(currentPreviewReport.state)
                                && <Button type='primary' ghost style={{ margin: '0 5px' }} onClick={() => this.showReturnedMsg({ returnType: 'defloss' })} danger>定损退回</Button>
                            }
                            {
                                isReportAgent
                                && canCollector
                                && ['holdedOn', 'returned'].includes(currentPreviewReport.state)
                                && <Popconfirm
                                    style={{ margin: '0 5px' }}
                                    title="确定查勘已完成?"
                                    onConfirm={this.onCpicConfirmSurveied}

                                    okText="确定"
                                    cancelText="取消"
                                >
                                    <Button type='primary' ghost style={{ borderColor: '#316DEE', color: '#316DEE' }}>已查勘</Button>
                                </Popconfirm>
                            }
                            {
                                ['untreated'].includes(currentPreviewReport.state)
                                && <Popover
                                    title='请选择结案类型'
                                    visible={this.state.isShowSubStateConfirm}
                                    trigger="click"
                                    content={
                                        <React.Fragment>
                                            <Radio.Group onChange={(e) => this.setState({ subState: e.target.value })} value={this.state.subState} >
                                                <Space direction="vertical">
                                                    {
                                                        <Radio value={'withdraw'} key={'withdraw'}>
                                                            {SUB_STATES['withdraw']}
                                                        </Radio>
                                                    }
                                                </Space>
                                            </Radio.Group>
                                            <div style={{ marginTop: 15 }}>
                                                <Button style={{ margin: '0 5px' }} size='small' onClick={() => this.setState({ isShowSubStateConfirm: false })}>取消</Button>
                                                <Button type='primary' size='small' onClick={this.onFinishClick}>确定</Button>
                                            </div>
                                        </React.Fragment>
                                    }
                                >
                                    <Button type='primary' ghost style={{ margin: '0 5px' }} onClick={() => this.setState({ isShowSubStateConfirm: true })} danger>已结案</Button>

                                </Popover>
                            }
                            {
                                isReportAgent
                                && ['holdedOn', 'returned', 'claiming', 'claimReturned'].includes(currentPreviewReport.state)
                                && <Popover
                                    title='请选择结案类型'
                                    visible={this.state.isShowSubStateConfirm}
                                    trigger="click"
                                    content={
                                        <React.Fragment>
                                            <Radio.Group onChange={(e) => this.setState({ subState: e.target.value })} value={this.state.subState} >
                                                <Space direction="vertical">
                                                    {
                                                        Object.keys(SUB_STATES)
                                                            .filter(k => {
                                                                return ['holdedOn', 'returned'].includes(currentPreviewReport.state)
                                                                    && !['withdraw'].includes(k) ? false : true;
                                                            })
                                                            .map(key => (
                                                                <Radio value={key} key={key}>
                                                                    {SUB_STATES[key]}
                                                                </Radio>
                                                            ))
                                                    }
                                                </Space>
                                            </Radio.Group>
                                            <div style={{ marginTop: 15 }}>
                                                <Button style={{ marginRight: '10px' }} size='small' onClick={() => this.setState({ isShowSubStateConfirm: false })}>取消</Button>
                                                <Button type='primary' size='small' onClick={this.onFinishClick}>确定</Button>
                                            </div>
                                        </React.Fragment>
                                    }
                                >
                                    <Button type='primary' ghost style={{ margin: '0 5px' }} onClick={() => this.setState({ isShowSubStateConfirm: true })} danger>已结案</Button>

                                </Popover>
                            }
                            <RemarkBtn currentAgent={currentAgent} flowId={flowId} />

                            <Modal visible={editVisible} title={editTitle} destroyOnClose onCancel={() => this.setState({ editVisible: false })} width={700} onOk={this.onSubmit} okText="保存" maskClosable={false}>
                                <Form layout="horizontal" initialValues={editData}  labelAlign="left" className="record-form" ref={this.recordFormRef}>
                                    <Form.Item name="time" label="时间" rules={[{ required: true, message: '请选择时间' }]}>
                                        <DatePicker showTime style={{ width: '100%' }} />
                                    </Form.Item>
                                    <Form.Item label="内容" style={{ marginBottom: 0 }}>
                                        <Form.List name="content" >
                                            {
                                                (fields, { add, remove }) => (
                                                    <React.Fragment>
                                                        {
                                                            fields.map((field, index) => <div key={field.key} className="form-list-item">
                                                                <Form.Item {...field} label={`第${index + 1}行`} rules={[{ required: true, message: '请输入内容' }]}>
                                                                    <TextArea placeholder='请输入' autoSize />
                                                                </Form.Item>
                                                                <Button type="link" danger onClick={() => remove(field.name)} disabled={fields.length <= 1}>删除</Button>
                                                            </div>)
                                                        }
                                                        <a onClick={() => add()} className="btn-delete">添加行</a>
                                                    </React.Fragment>
                                                )
                                            }
                                        </Form.List>
                                    </Form.Item>
                                </Form>
                            </Modal>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default withRouter(ProcessedRecords)